import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import SavedLocationEmpty from 'components/common/SavedLocationEmpty'
import SavedLocation from './SavedLocation'

const Location = ({ selectedStore, ...props }) =>
  <MapWrapper>
    {
      selectedStore ?
        <SavedLocation { ...props } data={ selectedStore } /> :
        <SavedLocationEmpty { ...props } />
    }
  </MapWrapper>

Location.propTypes = {
  selectedStore: PropTypes.shape()
}

export default Location

const MapWrapper = styled.div`
  position: relative;
  text-align: center;
`
